"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockFormFieldName = void 0;
var getBlockFormFieldName = function (blockType, fieldName, blockSubType) {
    var subType = blockSubType ? blockSubType.replace(/ /g, '_') : '';
    var returnValue = "".concat(blockType, "_");
    if (subType)
        returnValue += "".concat(subType, "_");
    returnValue += fieldName;
    return returnValue.toLowerCase();
};
exports.getBlockFormFieldName = getBlockFormFieldName;
